import React from 'react';
import {NavLink, withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {getRoute, PageRoutes} from "../../../../../api/utils/aemEndpointUtil";

function SidebarNavigationItem({mapping, title, route, onRouteChange, sidebar}) {
    const isDashboard = getRoute(mapping, PageRoutes.myPuratos) === route;
    const isAllProducts = getRoute(mapping, PageRoutes.allProducts) === route;
    //TODO: Create correct contact us comoponent, this is just hotfix for release
    const isContact = route === 'contact';
    const pageLanguage = window.location.pathname.split('/')[1];
    const contactLink = `/${pageLanguage}/contact-us`

    if (isAllProducts && sidebar.productFinderPath) {
        return (
            <>
                <li className="p-nav-side__item"
                    onClick={() => window.location.pathname = sidebar.productFinderPath}>
                    <a className="p-nav-side__link" href={sidebar.productFinderPath}>{title}</a>
                </li>
            </>
        )
    }

    return (
        <li className="p-nav-side__item" onClick={onRouteChange}>
            {!isContact ?
                <NavLink
                    exact={isDashboard}
                    className="p-nav-side__link"
                    to={`/${route}`}
                    activeClassName="active">{title}
                </NavLink> :
                <a className="p-nav-side__link" href={contactLink}>{title}</a>
            }
        </li>
    );
}

SidebarNavigationItem.defaultProps = {};

const mapStateToProps = (state) => ({
    mapping: state.myPuratos_dashboard.mapping,
    sidebar: state.myPuratos_navigation.sidebar,
});

export default withRouter(connect(mapStateToProps)(SidebarNavigationItem));
